import axios from "axios";
let source;
export default {
  request: function (url, method = "GET", data = null, cancelInit=false) {
    if (cancelInit && source) {
      source.cancel("cancel successfully");
    }
    source = axios.CancelToken.source();
    const options = {
      method,
      url,
      cancelToken: source.token,
    };
    if (data) options.data = data;
    return axios(options);
  },
  get: async function (url,cancel) {
    const res = await this.request(url, "GET");
    return res;
  },
  post: async function (url, data) {
    const res = await this.request(url, "POST", data);
    return res;
  },
  delete: async function (url, data) {
    const res = await this.request(url, "DELETE", data);
    return res;
  },
  put: async function (url, data) {
    const res = await this.request(url, "PUT", data);
    return res;
  },
};